export const formText = {
  mainHeading: "Send a Notice",
  buttons: {
    next: "Continue",
    previous: "Back",
    submit: "Publish",
  },
  progressSteps: {
    blanks: "Values",
    title: "Title",
    content: "Message",
    eventInfo: "Details",
    eventSettings: "Settings",
    eventPublish: "Scheduling",
    type: "Type",
    audience: "Audience",
    customizations: "Customizations",
    background: "Background",
    review: "Review",
    imageUpload: "Image",
    subcircle: "Subcircle",
    poll: "Poll",
  } as { [key: string]: string },
  labels: {
    title: "What's this notice about?",
    body: "What is this about?",
    type: "Notice Type",
    audience: "Target Audience",
    attachment: "Attachment",
  },
  descriptions: {
    title: "Choose an easy descriptive title for your notice.",
    body: "Write the main content of your notice",
    type: "Select the type of notice you want to create",
    audience: "Choose who should receive this notice",
    attachment: "Add any relevant attachments",
    background:
      "Pick a branded background for your custom event notice. This will be shown behind your event details in the app.",
  },
  placeholders: {
    title: "e.g. Friday sports day reminder 🏃‍♂️",
    body: "Write your notice content here...",
    attachment: "Upload a file...",
  },
  noticeTypes: [
    { id: "info", label: "Info", description: "General information notice" },
    {
      id: "event",
      label: "Event",
      description: "Notice about an upcoming event",
    },
    {
      id: "urgent",
      label: "Urgent",
      description: "Important notice requiring immediate attention",
    },
  ],
  errors: {
    title: {
      required: "Title is required",
      minLength: "Title must be at least 3 characters",
    },
    body: {
      required: "Content is required",
      minLength: "Content must be at least 10 characters",
    },
  },
};
